module.exports = __webpack_public_path__ + "img/business6-1_E.d0ed8d55.png";